import type { FC } from 'react';

import { Button, ModalFooter, ModalHeader, Paragraph } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

export const WaitProcessing: FC<{
  closeModal?: () => void;
}> = ({ closeModal }) => (
  <>
    <ModalHeader pt="3xl" pr="lg" pb="lg" pl="lg" textAlign="center">
      <Paragraph size="lg">{translate('Your downloads are still processing...')}</Paragraph>
    </ModalHeader>
    {closeModal && (
      <ModalFooter border="none" py="sm" px="lg">
        <Button onClick={closeModal}>{translate('OK')}</Button>
      </ModalFooter>
    )}
  </>
);
